import React from "react";
import { Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/AddOutlined";
import CommandKeyIcon from "@mui/icons-material/KeyboardCommandKeyOutlined";
import { commandKeyLabel, isMac } from "../../shared/platform";

// Muted ink on the white key caps, matching the search field's placeholder.
const CAP_INK = "rgba(0, 0, 0, 0.54)";

// A white key cap. Sized around a 17px glyph so the Mac command symbol and a
// "Ctrl" label both sit on the same baseline box.
const capSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 17,
  height: 17,
  px: "16px",
  py: "6px",
  borderRadius: "9px",
  background: "#FFFFFF",
  color: CAP_INK,
  fontSize: 16,
  lineHeight: 1.334,
  letterSpacing: "-0.9px",
};

// Discoverability hint for the keyboard shortcut that opens the launchpad from
// anywhere. It leads the launchpad's pinned footer, which the caller shows with
// the navigation and off mobile only - touch users have no keyboard.
export default function DashboardShortcutHint() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        // Asymmetric on purpose: the row sits well clear of the divider above
        // it, and close to the lock link that follows it.
        pt: "28px",
        pb: "8px",
      }}
    >
      <Typography
        sx={{ fontSize: 14, color: "#FFFFFF", letterSpacing: "-0.5px" }}
      >
        Open anywhere with
      </Typography>
      <Box component="kbd" sx={capSx}>
        {isMac ? (
          <CommandKeyIcon sx={{ fontSize: 17, color: CAP_INK }} />
        ) : (
          commandKeyLabel
        )}
      </Box>
      <AddIcon sx={{ fontSize: 18, color: "#FFFFFF" }} />
      <Box component="kbd" sx={capSx}>
        K
      </Box>
    </Box>
  );
}
